/**
 * Stop-Go lamp - two chambers for stop and go, red and green
 * - used in Charleroi
 * - needs to be adjusted for different cities when needed
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

export default class Sg extends Element {
  setDefaultShapes () {
    this.shapes.push(
      new Ren.Rect({
        name: 'go',
        x: 0,
        y: 0,
        width: 30,
        height: 30,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Ren.Rect({
        name: 'stop',
        x: 0,
        y: 30,
        width: 30,
        height: 30,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Ren.Circle({
        name: 'stopSignal',
        x: 15,
        y: 15,
        radius: 15,
        fill: Color.offlineGray
        // fill: Color.offlineGray
      }),

      new Ren.Circle({
        name: 'goSignal',
        x: 15,
        y: 45,
        radius: 15,
        fill: Color.offlineGray
        // fill: Color.offlineGray
      }),

      // signalling foor
      new Ren.Line({
        points: [15, 60, 15, 80],
        strokeWidth: 2,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [0, 80, 30, 80],
        strokeWidth: 2,
        opacity: 0.8
      })
    )
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(status)

    if (status.signalStop === 1) {
      this.modifyShape('goSignal', 'fill', Color.offlineGray)
      this.modifyShape('stopSignal', 'fill', 'red')
    } else if (status.signalGoStraight === 1 || status.signalGoLeft === 1 || status.signalGoRight === 1) {
      this.modifyShape('stopSignal', 'fill', Color.offlineGray)
      this.modifyShape('goSignal', 'fill', 'green')
    } else {
      this.modifyShape('stopSignal', 'fill', Color.offlineGray)
      this.modifyShape('goSignal', 'fill', Color.offlineGray)
    }
  }
}
